import React from 'react';
import { Link, Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../services/authContext';

export function ModerationRedirect({ section }: { section: 'contributions' | 'gallery' }) {
  const { search, hash } = useLocation();
  return <Navigate to={`/settings/moderation/${section}${search}${hash}`} replace />;
}

export default function ModerationSettings() {
  const { privileges } = useAuth();
  const sections = [
    { key: 'contributionReview' as const, path: 'contributions', title: 'Work & patch credit', description: 'Approve recorded work and correct contribution credit for patches.' },
    { key: 'photoModeration' as const, path: 'gallery', title: 'Gallery reports & hidden content', description: 'Review reported comments and restore or hide gallery content.' },
  ].filter(section => privileges[section.key]?.view);
  return <div className="space-y-6">
    <header><h2 className="text-2xl font-semibold">Moderation</h2><p className="text-sm text-gray-600 mt-2">Review contributions and reported content when something needs attention.</p></header>
    {sections.length ? <nav aria-label="Moderation tools" className="grid sm:grid-cols-2 gap-3">
      {sections.map(section => <Link key={section.path} to={`/settings/moderation/${section.path}`} className="block border rounded-xl bg-white p-4 hover:bg-gray-50"><span className="font-medium">{section.title}</span><span className="block text-sm text-gray-600 mt-1">{section.description}</span></Link>)}
    </nav> : <p role="status">Your current property permissions do not include moderation tools.</p>}
    <Outlet />
  </div>;
}
